/* Page Boutique : filtre par catégorie sans rechargement, dans la grille unique. Amélioration progressive : sans JavaScript, tous les produits restent visibles
   et les pastilles sont des ancres inertes. Maquette : js/boutique.js (applyFilter, keepInView, initBar).
   Marqueurs : [data-bq-root], [data-bq-tab="<clé>"][data-bq-type="<livre|planner|pack|merch, séparés par un espace>"], [data-bq-grid] > [data-type]. Le filtre se reflète dans l'adresse (#clé) : les liens du pied de page fonctionnent. */
import { $, $$, on } from 'mi/dom';

function init(root) {
  if (root.dataset.miInit) return; root.dataset.miInit = '1';
  const tabs = $$('[data-bq-tab]', root); const items = $$('[data-bq-grid] [data-type]', root);
  const bar = $('.bq-bar', root); const grid = $('[data-bq-grid]', root); const strip = $('.bq-tabs', root); const fade = $('.bq-bar__fade', root); const count = $('.bq-count', root);
  const keys = tabs.map((t) => t.dataset.bqTab);
  const typesOf = (k) => (((tabs.find((t) => t.dataset.bqTab === k) || {}).dataset || {}).bqType || '').split(' ');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const apply = (key) => {
    const k = keys.includes(key) ? key : 'all';
    let n = 0;
    tabs.forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.bqTab === k)));
    items.forEach((el) => {
      const show = k === 'all' || typesOf(k).includes(el.dataset.type);
      el.hidden = !show;
      if (show) { el.classList.add('is-in'); if (el.classList.contains('bq-card')) n += 1; }
    });
    if (count) count.textContent = n ? (n === 1 ? count.dataset.one : count.dataset.many.replace('{n}', n)) : '';
    root.classList.toggle('is-filtered', k !== 'all');
    const active = strip && strip.querySelector('[aria-pressed="true"]');
    if (strip && active && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: Math.max(0, active.offsetLeft - 16), behavior: reduce ? 'auto' : 'smooth' });
    return k;
  };
  /* Après un filtre la page raccourcit : le haut de la grille revient sous la barre collante. */
  const keepInView = () => {
    if (!bar || !grid) return;
    const top = bar.getBoundingClientRect().height + (parseFloat(getComputedStyle(bar).top) || 64);
    const gap = grid.getBoundingClientRect().top - top;
    if (gap < 0) window.scrollTo({ top: window.scrollY + gap - 8, behavior: 'auto' });
  };
  const upd = () => {
    if (!strip || !fade) return;
    fade.classList.toggle('is-fit', strip.scrollWidth <= strip.clientWidth + 1);
    fade.classList.toggle('is-end', strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4);
  };
  /* Anciennes ancres (#merchandising, #merch, #packs) : le merch fait partie des Box. */
  const alias = { merchandising: 'box', merch: 'box', packs: 'box' };
  const fromHash = () => { const h = (location.hash || '').replace('#', ''); return keys.includes(h) ? h : (alias[h] && keys.includes(alias[h]) ? alias[h] : h); };
  apply(fromHash() || 'all'); upd();
  if (strip) { on(strip, 'scroll', upd, { passive: true }); on(window, 'resize', upd); }
  tabs.forEach((t) => on(t, 'click', (e) => {
    e.preventDefault();
    const k = apply(t.dataset.bqTab); keepInView();
    try { history.replaceState(null, '', k === 'all' ? location.pathname + location.search : '#' + k); } catch (err) { /* adresse inchangée */ }
  }));
  on(window, 'hashchange', () => { const k = fromHash(); if (!k || keys.includes(k)) { apply(k || 'all'); window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); } });
}
const boot = () => $$('[data-bq-root]').forEach(init);
boot();
document.addEventListener('shopify:section:load', boot);
